module.exports = __webpack_public_path__ + "2_View_Goal_Progress_Modal-0e3c393d0922f54fcdfcd7ef4d50376b.png";